export const PRIORITY_VALUES = ["OPTIONAL", "FAVOURABLE", "NECESSARY"]